module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-double-up-523accca.svg";